import { useQueryClient } from '@tanstack/react-query';
import React from 'react'
import { IoIosArrowForward } from 'react-icons/io'
import { Link } from 'react-router-dom'
import { updateTapCount } from '../../../helpers/tapCountMutation';

function ReviewCardCls({ review, preview, Textcolor }) {

    /* ------------------ tap count taking using tanstack query ----------------- */

    const queryClient = useQueryClient();

    const handleTap = (button, id) => {
        // console.log("iiii", id);

        updateTapCount(queryClient, button, id);
    };

    return (
        <div>
            {review?.map((review) => (
                <div className="flex justify-between items-center p-2 ">
                    <Link
                        onClick={() => handleTap('reviews', review._id)}
                        to={review?.reviewUrl}
                        target={`${preview ? "_blank" : ""}`}
                    >
                        <h5 className='mt-3 text-[18px]'
                            style={{
                                color: `${Textcolor ? Textcolor : ""}`,
                            }}
                        >
                            {review?.reviewName ? review?.reviewName : ""}
                        </h5>
                    </Link>
                    <IoIosArrowForward size={23} color={Textcolor ? Textcolor : 'black'} />
                </div>
            ))}
        </div>
    )
}

export default ReviewCardCls